import {
  DynamicFieldPage,
  SuiClient,
  SuiMoveObject,
  SuiObjectData, SuiObjectDataOptions,
  SuiObjectResponse,
  SuiParsedData
} from "@mysten/sui/client";
import {DataPage, PaginationArgs} from "../types";

export function getObjectFields(object: SuiObjectResponse | SuiObjectData): any {
  const fields = getMoveObject(object)?.fields
  if (fields) {
    if ('fields' in fields) {
      return fields.fields
    }
    return fields
  }
  return undefined
}

export function getMoveObject(data: SuiObjectResponse | SuiObjectData): SuiMoveObject | undefined {
  const suiObject = 'data' in data ? getSuiObjectData(data) : (data as SuiObjectData)

  if (!suiObject || !isSuiObjectDataWithContent(suiObject) || suiObject.content.dataType !== 'moveObject') {
    return undefined
  }

  return suiObject.content as SuiMoveObject
}

export function getSuiObjectData(resp: SuiObjectResponse): SuiObjectData | null | undefined {
  return resp.data
}

function isSuiObjectDataWithContent(data: SuiObjectData): data is SuiObjectDataWithContent {
  return data.content !== undefined
}

export interface SuiObjectDataWithContent extends SuiObjectData {
  content: SuiParsedData
}

export function getObjectType(resp: SuiObjectResponse | SuiObjectData): string | null | undefined {
  const data = isSuiObjectResponse(resp) ? resp.data : resp

  if (!data?.type && 'data' in resp) {
    if (data?.content?.dataType === 'package') {
      return 'package'
    }
    return getMoveObjectType(resp)
  }
  return data?.type
}

export function isSuiObjectResponse(resp: SuiObjectResponse | SuiObjectData): resp is SuiObjectResponse {
  return (resp as SuiObjectResponse).data !== undefined
}

export function getMoveObjectType(resp: SuiObjectResponse): string | undefined {
  return getMoveObject(resp)?.type
}

/**
 * Return the list of dynamic field objects owned by an object
 * @param parent_id
 * @param pagination_args
 * @returns
 */
export async function getDynamicFieldsByPage(suiClient: SuiClient, parent_id: string, pagination_args: PaginationArgs = 'all'): Promise<DataPage<any>> {
  let result: any = []
  let has_next_page = true
  const query_all = pagination_args === 'all'
  let nextCursor = query_all ? null : pagination_args.cursor
  do {
    const res: DynamicFieldPage = await suiClient.getDynamicFields({
      parentId: parent_id,
      cursor: nextCursor,
      limit: query_all ? null : pagination_args.limit,
    })

    if (res.data) {
      result = [...result, ...res.data]
      has_next_page = res.hasNextPage
      nextCursor = res.nextCursor
    } else {
      has_next_page = false
    }
  } while (query_all && has_next_page)

  return {data: result, next_cursor: nextCursor, has_next_page: has_next_page}
}


/**
 * Batch get details about a list of objects. If any of the object ids are duplicates the call will fail
 * @param ids
 * @param options
 * @param limit
 * @returns
 */
export async function batchGetObjects(suiClient: SuiClient, ids: string[], options?: SuiObjectDataOptions, limit = 50): Promise<SuiObjectResponse[]> {
  let object_data_responses: SuiObjectResponse[] = []

  try {
    for (let i = 0; i < Math.ceil(ids.length / limit); i++) {
      const res = await suiClient.multiGetObjects({
        ids: ids.slice(i * limit, limit * (i + 1)),
        options,
      })
      object_data_responses = [...object_data_responses, ...res]
    }
  } catch (error) {
    console.log(error)
  }

  return object_data_responses
}
